<div class="d-flex align-items-start">
  <div class="col-5 asset-card-content-title">{{ attributeValue.name }}</div>
  <div class="col-7 asset-card-content-value">
    <input
      type="text"
      class="form-control edit-input"
      [class.is-invalid]="!!error"
      [placeholder]="attributeValue.placeholderText ?? ''"
      [attr.maxlength]="attributeValue.maxNumberValue ?? null"
      [(ngModel)]="value"
      (ngModelChange)="onValueChange($event)"
    />
    <div *ngIf="error" class="invalid-feedback d-block">
      {{ error.key | translate: error.params }}
    </div>
  </div>
</div>
